<div class="container app-page-titles--hierarchy">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading"></i>
  </div>
  }
  <div class="grid client-data-header">

    <div class="col-12 md:col-12 lg:col-8 client-data-title-position client-data-main-header">

      <h1 class="client-data-title client-data-main-title app-page-title--primary">{{ 'TRANSLATE.CLIENT.DATA' |
        translate }}</h1>
      <span class="client-data-subtitle" id="subTitle">
        {{ 'TRANSLATE.ENTER.DOCUMENT.CHECK.THIS.PERSON.COMPANY.ALREADY.REGISTERED' | translate }}
      </span>
    </div>

    <div class="col-12 md:col-12 lg:col-12">

      <div class="check-document">

        <div class="col-12 md:col-12 lg:col-5 documents-itens">

          <div class="col-12 md:col-9 lg:col-9 filling-item">

            <label class="documents-itens-label" for="customerDocument">
              {{'TRANSLATE.ENTER.THE.REQUIRED.DOCUMENT' | translate }}
            </label>
            <input class="documents-itens-input" placeholder="{{ 'TRANSLATE.TYPE.THE.DOCUMENT' | translate }}"
              id="customerDocument" type="text" [maxlength]="maxLenghtDocument" [minlength]="minLenghtDocument"
              [(ngModel)]="informedCustomerDocument" (ngModelChange)="onCustomerDocumentChange($event)"
              (blur)="inputValidatingClientDocument($event)" pInputText>

          </div>

          <div class="document-feedback-slot" aria-live="polite">
            @if (systemCountry !== 'BRA' && validCustomerDocument === null) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.FILL.CPF.CNPJ.CORRECTLY' | translate }}">
            </p-message>
            }

            @if (emptyCustomerDocument === true) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.DOCUMENT.EMPTY' | translate }}">
            </p-message>
            }

            @if (systemCountry === 'BRA' && invalidCpf === null) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.CPF.INVALID' | translate }}">
            </p-message>
            }

            @if (systemCountry === 'BRA' && invalidCnpj === null) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.CNPJ.INVALID' | translate }}">
            </p-message>
            }

            @if (invalidDocument === null) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INVALID.DOCUMENT' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-2 lg:col-2 filling-item">

          <button id="btnConsult" class="btn-consult app-filter-button" type="button" (click)="buttonConsult()">
            <i class="pi pi-search" aria-hidden="true"></i>
            <span class="btn-consult-label">{{ 'TRANSLATE.CONSULT.DOCUMENT' | translate }}</span>
          </button>
        </div>

        @if (!showRegistrationForm) {
        <div class="client-data-preform-actions">
          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonComeBack()">
            <i class="pi pi-arrow-left" aria-hidden="true"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>
        </div>
        }
      </div>
    </div>
  </div>

  <div *ngIf="showRegistrationForm">

    <div class="container-form">

      <div class="col-12 md:col-12 lg:col-8 client-data-title-position app-page-title-block--nested">
        <span class="client-data-title app-page-title--section">
          {{ 'TRANSLATE.REGISTRATION.DATA' | translate }}
        </span>
        <span class="client-data-subtitle app-page-subtitle--section" id="secondSubtitle">
          {{ 'TRANSLATE.COMPLETE.OR.UPDATE.THE.INFORMATION.BELOW' | translate }}
        </span>
      </div>

      <form [formGroup]="customerForm">

        <div class="form-client-data">

          <div class="col-12 md:col-12  lg:col-7 input-wrapper" [ngClass]="countryPlg">

            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="nameOrCompanyName">
                {{'TRANSLATE.BUSINESS.NAME' | translate }}
              </label>
              <input class="input-wrapper-input" id="nameOrCompanyName" formControlName="inputName"
                [maxlength]="nameMaxLength" minlength="2" [(ngModel)]="clientData.firstname"
                placeholder="{{ 'TRANSLATE.NAME.OR.COMPANY.NAME' | translate }}" type="text"
                (keydown)="preventInvalidCustomerNameDigits($event)"
                (paste)="handleCustomerNamePaste($event)"
                (input)="onNameFieldInput($event)" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.firstname?.length || 0), max: nameMaxLength } }}</span>
            </div>

            @if (customerForm.controls['inputName'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputName', 'TRANSLATE.INFORM.YOUR.NAME.BUSINESS') | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">

            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="surName">
                {{'TRANSLATE.LAST.NAME' | translate }}
              </label>
              <input class="input-wrapper-input" id="surName" formControlName="inputLastName" maxlength="50"
                minlength="2" [(ngModel)]="clientData.lastname"
                placeholder="{{ 'TRANSLATE.ENTER.LAST.NAME' | translate }}" type="text"
                (keydown)="preventDigitsInLettersFields($event)"
                (paste)="handleLettersFieldPaste($event, 'inputLastName', 'lastname', 50)"
                (input)="removeDigitsFromLettersFieldInput($event, 'inputLastName', 'lastname', 50)" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.lastname?.length || 0), max: 50 } }}</span>
            </div>

            @if (customerForm.controls['inputLastName'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputLastName', 'TRANSLATE.INFORM.LAST.NAME') | translate }}">
            </p-message>
            }
          </div>

          @if (systemCountry === 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 filling-item">
              <label class="input-wrapper-label" for="customerSocialName">
                {{'TRANSLATE.SOCIAL.NAME' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerSocialName" formControlName="inputSocialName"
                maxlength="50" [(ngModel)]="clientData.customerSocialName"
                placeholder="{{ 'TRANSLATE.OPTIONAL.FIELD' | translate }}" type="text"
                (keydown)="preventDigitsInLettersFields($event)"
                (paste)="handleLettersFieldPaste($event, 'inputSocialName', 'customerSocialName', 50)"
                (input)="removeDigitsFromLettersFieldInput($event, 'inputSocialName', 'customerSocialName', 50)"
                pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.customerSocialName?.length || 0), max: 50 } }}</span>
            </div>
          </div>
          }

          @if (systemCountry === 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 filling-item">
              <label class="input-wrapper-label" for="customerDateOfBirth">
                {{ 'TRANSLATE.BIRTH.DATE' | translate }}
              </label>
              <input class="input-wrapper-input" (click)="picker.open()" matInput [matDatepicker]="picker"
                placeholder="{{ 'TRANSLATE.SELECT.BIRTH.DATE' | translate }}" [max]="maxBirthDate"
                formControlName="inputBirthDate" [(ngModel)]="clientData.birthDate" id="customerDateOfBirth">
              <mat-datepicker #picker></mat-datepicker>
            </div>
            @if (systemCountry === 'BRA' && customerForm.controls['inputBirthDate'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputBirthDate', 'TRANSLATE.INFORM.BIRTH.DATE') | translate }}">
            </p-message>
            }
          </div>
          }

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">

            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="customerPhoneNumber">
                {{'TRANSLATE.PHONE' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerPhoneNumber" formControlName="inputPhoneNumber"
                [(ngModel)]="clientData.phone1" placeholder="{{ 'TRANSLATE.ENTER.PHONE.NUMBER' | translate }}"
                [maxlength]="phoneMaxLength" [minlength]="phoneMinLength" type="text"
                (keydown)="allowOnlyDigits($event)" (paste)="handlePhonePaste($event)"
                (input)="enforceNumericPhoneInput($event)" inputmode="numeric" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.phone1?.length || 0), max: phoneMaxLength } }}</span>
            </div>

            @if (customerForm.controls['inputPhoneNumber'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputPhoneNumber', 'TRANSLATE.INFORM.PHONE') | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">

            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="customerEmail">
                {{'TRANSLATE.EMAIL' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerEmail" formControlName="inputEmail"
                [(ngModel)]="clientData.email1" placeholder="{{ 'TRANSLATE.ENTER.EMAIL' | translate }}" maxlength="50"
                minlength="2" type="text" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.email1?.length || 0), max: 50 } }}</span>
            </div>

            @if (customerForm.controls['inputEmail'].pending || (customerForm.controls['inputEmail'].invalid &&
            customerForm.controls['inputEmail'].touched)) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputEmail', 'TRANSLATE.INFORM.EMAIL') | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">

            <div class="col-12 md:col-12 lg:col-12 filling-item">
              <label class="input-wrapper-label" for="customerZipCode">
                {{'TRANSLATE.CEP' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerZipCode" formControlName="inputZipCode" type="text"
                [(ngModel)]="clientData.zip" placeholder="{{ 'TRANSLATE.ENTER.ZIP.CODE' | translate }}"
                [maxlength]="zipMaxLength" [minlength]="zipMinLength" (keydown)="allowOnlyDigits($event)"
                (paste)="handlePhonePaste($event)" (input)="onZipInput($event)" inputmode="numeric" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.zip?.length || 0), max: zipMaxLength } }}</span>
              @if (shouldShowZipLookupProgress) {
              <div class="zip-lookup-feedback" aria-live="polite" aria-busy="true">
                <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                <span>{{ 'TRANSLATE.CLIENT.DATA.ZIP.SEARCHING.ADDRESS' | translate }}</span>
              </div>
              }
            </div>

            @if (customerForm.controls['inputZipCode'].invalid && (customerForm.controls['inputZipCode'].touched || customerForm.controls['inputZipCode'].pending)) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputZipCode', 'TRANSLATE.INFORM.CEP.CORRECT') | translate }}">
            </p-message>
            }
            @if (shouldShowZipValidationError()) {
            <p-message class="client-data-message" severity="error"
            text="{{ getLocationValidationMessage() }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-12 street-number">

            <div class="col-12 md:col-12 lg:col-8 input-number address-field">

              <div class="col-12 md:col-12 lg:col-12">

                <label class="input-number-label" for="customerAddress">
                  {{'TRANSLATE.ADDRESS' | translate }}
                </label>
                <input class="input-number-input" id="customerAddress" formControlName="inputAddress" type="text"
                  minlength="2" maxlength="200" [(ngModel)]="clientData.address"
                  [disabled]="shouldShowZipLookupProgress"
                  placeholder="{{ 'TRANSLATE.STREET.INFORMATION' | translate }}" pInputText>
                <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                  (clientData.address?.length || 0), max: 200 } }}</span>
              </div>

              @if (customerForm.controls['inputAddress'].pending ||
                    (customerForm.controls['inputNumber'].invalid && customerForm.controls['inputNumber'].touched)) {
              <p-message class="client-data-message" severity="error"
                text="{{ getFieldValidationMessage('inputAddress', 'TRANSLATE.INFORM.ADDRESS.CORRECT') | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-12 lg:col-3 input-number number-field">

              <div class="col-12 md:col-12 lg:col-12">

                <label class="input-number-label" for="customerHouseNumber">
                  {{'TRANSLATE.NUMBER' | translate }}
                </label>
                
                  <input class="input-number-input" id="customerHouseNumber" formControlName="inputNumber" type="text"
                  [(ngModel)]="clientData.number" [minlength]="2" [maxlength]="propertyNumberMaxLength"
                  [disabled]="shouldShowZipLookupProgress" placeholder="{{ 'TRANSLATE.ENTER.NUMBER' | translate }}"
                  pInputText>
                
                <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                  (clientData.number?.length || 0), max: propertyNumberMaxLength } }}</span>
              </div>

              @if (customerForm.controls['inputNumber'].pending) {
              <p-message class="client-data-message" severity="error"
                text="{{ getFieldValidationMessage('inputNumber', 'TRANSLATE.INFORM.NUMBER') | translate }}">
              </p-message>
              }
            </div>

          </div>

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">

            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="customerDistrict">
                {{'TRANSLATE.SURROUND' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerDistrict" formControlName="inputDistrict"
                [(ngModel)]="clientData.district" placeholder="{{ 'TRANSLATE.ENTER.DISTRICT' | translate }}" type="text"
                maxlength="100" [disabled]="shouldShowZipLookupProgress" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.district?.length || 0), max: 100 } }}</span>
            </div>

            @if (customerForm.controls['inputDistrict'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputDistrict', 'TRANSLATE.INFORM.SURROUND') | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 filling-item">

              <label class="input-wrapper-label" for="customerComplement">
                {{'TRANSLATE.COMPLEMENT' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerComplement" formControlName="inputComplement"
                [(ngModel)]="clientData.complement" placeholder="{{ 'TRANSLATE.ENTER.COMPLEMENT' | translate }}"
                type="text" maxlength="200" [disabled]="shouldShowZipLookupProgress" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.complement?.length || 0), max: 200 } }}</span>
            </div>
          </div>

          @if (systemCountry !== 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 filling-item">
              <label class="input-wrapper-label" for="customerCity">
                {{'TRANSLATE.CITY' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerCity" formControlName="inputCity"
                [(ngModel)]="clientData.city" placeholder="{{ 'TRANSLATE.ENTER.CITY' | translate }}" type="text"
                minlength="2" maxlength="50" (keydown)="preventDigitsInLettersFields($event)"
                (paste)="handleLettersFieldPaste($event, 'inputCity', 'city', 50)"
                (input)="removeDigitsFromLettersFieldInput($event, 'inputCity', 'city', 50)" pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.city?.length || 0), max: 50 } }}</span>
            </div>
            @if (customerForm.controls['inputCity'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputCity', 'TRANSLATE.INFORM.CITY') | translate }}">
            </p-message>
            }
          </div>
          }

          @if (systemCountry !== 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 filling-item">
              <label class="input-wrapper-label" for="customerState">
                {{'TRANSLATE.STATE' | translate }}
              </label>
              <input class="input-wrapper-input" id="customerState" formControlName="inputState"
                [(ngModel)]="clientData.stateCode" placeholder="{{ 'TRANSLATE.ENTER.STATE' | translate }}" type="text"
                minlength="2" [maxlength]="stateNumberMaxLength" (keydown)="preventDigitsInLettersFields($event)"
                (paste)="handleLettersFieldPaste($event, 'inputState', 'stateCode', stateNumberMaxLength)"
                (input)="removeDigitsFromLettersFieldInput($event, 'inputState', 'stateCode', stateNumberMaxLength)"
                pInputText>
              <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (clientData.stateCode?.length || 0), max: stateNumberMaxLength } }}</span>
            </div>
            @if (customerForm.controls['inputState'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ getFieldValidationMessage('inputState', 'TRANSLATE.INFORM.STATE') | translate }}">
            </p-message>
            }
          </div>
          }

          @if (systemCountry === 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-12 element-add-edit">
              <label class="element-add-edit-filter" for="customerState">
                {{'TRANSLATE.STATE' | translate }}
              </label>
              <p-dropdown [placeholder]="('TRANSLATE.ENTER.STATE' | translate)" [options]="statesList"
                [(ngModel)]="clientData.stateCode" id="customerState" formControlName="optionState"
                [styleClass]="shouldShowStateValidationError() ? 'ng-invalid ng-dirty' : ''"
                (onChange)="stateChange($event)" [style]="{'minWidth': '100%'}" [filter]="true" filterBy="label"
                [filterPlaceholder]="('TRANSLATE.DROPDOWN.FILTER.PLACEHOLDER' | translate)" [appendTo]="'body'"
                [disabled]="disableState || shouldShowZipLookupProgress">
                <ng-template pTemplate="item" let-item>
                  {{ item?.label }}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label }}
                </ng-template>
              </p-dropdown>
              @if (showLocationRequiredErrors && (selectedState === null || selectedState === '')) {
              <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.STATE' | translate }}">
              </p-message>
              }
              @if (shouldShowStateValidationError()) {
              <p-message class="client-data-message" severity="error"
              text="{{ getLocationValidationMessage() }}">
              </p-message>
              }
            </div>
          </div>
          }

          @if (systemCountry === 'BRA') {
          <div class="col-12 md:col-12 lg:col-7 input-wrapper">
            <div class="col-12 md:col-12 lg:col-5 element-add-edit">
              <label class="element-add-edit-filter" for="customerCity">
                {{ 'TRANSLATE.CITY' | translate }}
              </label>
              @if (renderCityDropdown) {
              <p-dropdown
                [placeholder]="disableCity ? ('TRANSLATE.SELECT.STATE.FIRST' | translate) : ('TRANSLATE.ENTER.CITY' | translate)"
                [options]="citiesList" [(ngModel)]="clientData.city" id="customerCity" formControlName="optionCity"
                [styleClass]="shouldShowCityValidationError() ? 'ng-invalid ng-dirty' : ''"
                (onChange)="cityChange($event)" [style]="{'minWidth': '100%'}" [filter]="true" filterBy="label"
                [filterPlaceholder]="('TRANSLATE.DROPDOWN.FILTER.PLACEHOLDER' | translate)" [appendTo]="'body'"
                [disabled]="disableCity || shouldShowZipLookupProgress">
                <ng-template pTemplate="item" let-item>
                  {{ item?.label }}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label }}
                </ng-template>
              </p-dropdown>
              }
              @if (showLocationRequiredErrors && (selectedCity === null || selectedCity === '')) {
              <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.CITY' | translate }}">
              </p-message>
              }
              @if (shouldShowCityValidationError()) {
              <p-message class="client-data-message" severity="error"
              text="{{ getLocationValidationMessage() }}">
              </p-message>
              }
            </div>
          </div>
          }

        </div>

        <div class="col-12 md:col-12 lg:col-8 button-position">

          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonComeBack()">
            <i class="pi pi-arrow-left" aria-hidden="true"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>

          <app-cta-button id="btnAdvance" [label]="'TRANSLATE.ADVANCE'" [successState]="isCtaSuccess"
            [disabled]="blockedUi" (buttonClick)="buttonNext()">
          </app-cta-button>

        </div>

      </form>

    </div>

  </div>

</div>